module.exports = __webpack_public_path__ + "static/media/icon-question.277cd949.svg";